import { useMemo } from 'react';

import PageSection from '@sayyesschool/frontend/components/page-section';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';
import { Button } from '@sayyesschool/frontend/ui-components';

import LessonsList from '@/components/lessons/lessons-list';

const MAX_VISIBLE_LESSONS = 5;

export default function TeacherLessons({ teacher }) {
    const [isExpanded, toggleExpanded] = useBoolean(false);

    const lessons = useMemo(() => teacher.lessons ?? [], [teacher.lessons]);

    const visibleLessons = useMemo(() => (
        isExpanded ? lessons : lessons.slice(0, MAX_VISIBLE_LESSONS)
    ), [lessons, isExpanded]);

    return (
        <PageSection
            className="TeacherLessons"
            title="Уроки"
            compact
        >
            {lessons.length > 0 &&
                <LessonsList lessons={visibleLessons} />
            }

            {lessons.length > MAX_VISIBLE_LESSONS &&
                <Button
                    content={isExpanded ? 'Скрыть' : 'Показать все'}
                    variant="plain"
                    size="sm"
                    fullWidth
                    onClick={toggleExpanded}
                />
            }
        </PageSection>
    );
}